/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-04-06 18:15:17
 * @LastEditTime: 2025-04-29 17:25:55
 * @LastEditors: didan
 */
import router from './router';
import store from './store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, setToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { getCookie } from '@/utils/cookie';
import { checkCurrentBusinessPermission } from '@/config/waybill-data-whitelist';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  '/login',
  '/auth-redirect',
  '/onestop/deal',
  '/onestop/policy',
  '/onestop/public/contract',
  '/transfer',
  '/register',
]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);
  const ShippersUserInfo = getCookie('ShippersUserInfo')
    ? JSON.parse(getCookie('ShippersUserInfo'))
    : {};
  if (ShippersUserInfo && ShippersUserInfo.accessToken) {
    setToken(ShippersUserInfo.accessToken);
  }

  // 运单数据页面权限检查
  if (to.name === 'waybillData') {
    if (!checkCurrentBusinessPermission()) {
      NProgress.done();
      next('/404');
      return;
    }
  }

  // determine whether the user has logged in
  const hasToken = getToken();
  NProgress.done();
  next();
  if (hasToken) {
    if (to.path.includes('/login')) {
      // if is logged in, redirect to the home page
      next({ path: `/` });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else if (whiteList.indexOf(to.path) !== -1) {
      console.log('whiteList-路由跳转前');
      NProgress.done();
      next();
    } else {
      await store.dispatch('permission/getSetting');
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      console.log('hasRoles', hasRoles);
      if (hasRoles) {
        next();
      } else {
        try {
          const { roles } = await store.dispatch('user/getInfo');
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles);
          router.addRoutes(accessRoutes);
          next({ ...to, replace: true });
        } catch (error) {
          // await store.dispatch('user/resetToken');
          // Message.error(error || 'Has Error');
          // next(`/login?redirect=${to.path}`);
          // NProgress.done();
        }
      }
    }
  } else {
    console.log('permission', to.path, whiteList.indexOf(to.path));
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
